interface Item {
  id: number;
  src: string;
  title: string;
}

const MockData: Array<Item> = [
  {
    id: 1,
    src: `/img/fumes.webp`,
    title: `Fumes`
  },
  {
    id: 2,
    src: `/img/all-that-is-needed.webp`,
    title: `All that is needed`
  },
  {
    id: 3,
    src: `/img/in-desert.webp`,
    title: `In desert`
  },
  {
    id: 4,
    src: `/img/in-the-forest.webp`,
    title: `In the forest`
  },
  {
    id: 5,
    src: `/img/sunset.webp`,
    title: `Sunset`
  },
  {
    id: 6,
    src: `/img/way-of-life.webp`,
    title: `Way of life`
  },
  {
    id: 7,
    src: `/img/winter-has-come.webp`,
    title: `Winter has come`
  },
];

export default MockData;

export {Item};
